import { render, staticRenderFns } from "./PolicySummaryQuestion.vue?vue&type=template&id=57523798&scoped=true"
import script from "./PolicySummaryQuestion.vue?vue&type=script&lang=js"
export * from "./PolicySummaryQuestion.vue?vue&type=script&lang=js"
import style0 from "./PolicySummaryQuestion.vue?vue&type=style&index=0&id=57523798&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57523798",
  null
  
)

export default component.exports